import React from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Switch, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

// Custom Input Component
export const CustomInput = ({
    label,
    name,
    value,
    type = 'text',
    placeholder,
    options = [],
    error = '',
    helperText = '',
    onChange,
    onSwitchChange,
    isSwitch = false,
    disabled = false,
    inputProps = {},
    selectProps = {},
}) => {
    // Function to determine border color based on error
    const getBorderColor = (fieldError) => {
        if (typeof value === 'string') {
            return fieldError ? 'red' : value.trim() !== '' ? '#0D6EFD' : '';
        }
        return fieldError ? 'red' : value ? '#0D6EFD' : '';
    };

    return (
        <>
            {/* Render Switch if the input isSwitch */}
            {isSwitch ? (
                <FormControlLabel
                    control={
                        <Switch
                            checked={value}
                            onChange={onSwitchChange}
                            name={name}
                        />
                    }
                    label={label}
                    sx={{ flex: '1 1 100%', mt: 0 }}
                />
            ) : type === 'select' ? (
                // Render Select if the type is select
                <FormControl fullWidth margin="dense" sx={{ flex: '1 1 23%', mt: 0 }}>
                    <InputLabel sx={{ background: '#fff', px: 1 }}>{label}</InputLabel>
                    <Select
                        name={name}
                        value={value}
                        onChange={onChange}
                        error={!!error}
                        disabled={disabled}
                        sx={{
                            borderRadius: 2,
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: getBorderColor(error),
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: getBorderColor(error),
                            },
                            '& .MuiSelect-icon': {
                                color: getBorderColor(error),
                            },
                        }}
                        {...selectProps}
                    >
                        {options.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && (
                        <Typography variant="caption" color="error">
                            <WarningIcon sx={{ fontSize: 16, mr: 0.5 }} /> {helperText || error}
                        </Typography>
                    )}
                </FormControl>
            ) : (
                <TextField
                    fullWidth
                    label={label}
                    name={name}
                    type={type}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    margin="dense"
                    error={!!error}
                    helperText={
                        error ? (
                            <>
                                <WarningIcon sx={{ fontSize: 16, mr: 0.5 }} /> {helperText || error}
                            </>
                        ) : ''
                    }
                    disabled={disabled}
                    inputProps={inputProps}
                    sx={{
                        flex: '1 1 23%',
                        '& .MuiOutlinedInput-root': {
                            borderColor: getBorderColor(error),
                            '& fieldset': {
                                borderColor: getBorderColor(error),
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: getBorderColor(error),
                            },
                        },
                        mt: 0,
                    }}
                />
            )}
        </>
    );
};
